'use client';
import { useMenuContext } from '@srcDS/provider/menu/MenuContext';
import PrimaryLoader from '@srcDS/components/atoms/primaryLoader/PrimaryLoader';
import React, { ChangeEvent } from 'react';
import useDebounce from '../../../utils/useDebounce';
import { SearchLens1 } from '@srcDS/components/atoms/icons';
import styles from './SearchInput.module.scss';
import clsx from 'clsx';
import { useLayoutContext } from '@srcDS/provider/layout/LayoutContext';
import { useSearchProductsApi } from '@srcDS/components/organisms/searchDropdown/hooks/useSearchProductsApi';
import { useNostoContext } from '@srcDS/provider/nosto/NostoContext';

interface SearchInputProps {
  isInvertedClass: string;
  isHidden: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({ isInvertedClass = '', isHidden = false }) => {
  const { setShowSearchDropdown, searchValue, onChangeSearch, gotToSearchPage, setSearchResults, isLoadingSearchPage } = useLayoutContext();
  const { nostoSearchOnChange, nostoRecordSearchSubmit } = useNostoContext();
  const { getSearchResults } = useSearchProductsApi();
  const { setActiveLevel1 } = useMenuContext();

  const handleMouseOver = () => {
    setActiveLevel1(null);
  };

  const getProducts = async (value: string) => {
    const data = await getSearchResults(value);
    nostoSearchOnChange({ type: 'autocomplete', searchRequest: { query: value }, searchResults: data });
    return data;
  };

  const debouncedSearch = useDebounce(async (value: string) => {
    const data = await getProducts(value);
    setSearchResults(data);
  }, 400);

  const gotToSearchPageHandler = async (value: string) => {
    nostoRecordSearchSubmit(value);
    gotToSearchPage(value);
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeSearch(e.target.value);
    debouncedSearch(e.target.value);
  };

  return (
    <div
      className={clsx(styles.root, isInvertedClass, { [styles.isHidden]: isHidden })}
      onMouseOver={handleMouseOver}
    >
      {isLoadingSearchPage && <PrimaryLoader mode={'global'} borderWidth={undefined} />}
      <div className={styles.inputWrapper}>
        <span className={clsx(styles.icon, isInvertedClass)} onClick={() => gotToSearchPageHandler(searchValue)}>
          <SearchLens1 />
        </span>
        <input
          id="header-search-input"
          className={styles.inputField}
          placeholder="Search products"
          type="search"
          onChange={onChange}
          onFocus={() => setShowSearchDropdown(true)}
          value={searchValue}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              gotToSearchPageHandler(searchValue);
            }
          }}
        />
      </div>
    </div>
  );
};

export default SearchInput;
